import { Divider, InputAdornment, Typography } from '@mui/material'
import InputTextField from '../../../component/input/inputTextField'
import { icons } from '../../../constants/images'
import ButtonCustom from '../../../component/button/buttonCustom'
import { useNavigate } from 'react-router-dom';
import LoginApi from '../../../api/auth/auth.api';
import { useState } from 'react';
import { swalError } from '../../../component/notification/swal';
import { useTranslation } from 'react-i18next';
const initStateErrorMessage = {
    EMAIL: "",
};
export default function ForgotPassword() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [email, setEmail] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState<any>(initStateErrorMessage);
    const clearErrorMessage = () => setErrorMessage(initStateErrorMessage);
    const submit = async () => {
        if (!email.includes('@'))
            return setErrorMessage({
                ...errorMessage,
                ...{ EMAIL: t('FORGOT_PASSWORD.MESSAGE.EMAIL') },
            });
       
        setLoading(true);

        await LoginApi.forgotPassword(email)
            .then(async ({ data }) => {
                if (data.result) {
                    setLoading(false);
                    navigate('/OTP-confim', { state: { email: email, ref: data.result.ref } })

                } else {
                    swalError(data.description);
                    setLoading(false)
                }
            })
            .catch((e) => {
                setLoading(false);
                swalError(e.response.data.description || e.response.data.message);
            })
            .finally(() => {
                setLoading(false);
            })
    };
    return (
        <div style={{
            width: "100%",
            gap: '36px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
        }}>
            <Divider orientation="horizontal" flexItem>
                <Typography sx={{ color: '#858C95' }}>{t('FORGOT_PASSWORD.TITLE')}</Typography>
            </Divider>
            <div style={{ width: "100%", }}>
                <InputTextField heading={t('FORGOT_PASSWORD.INPUT.EMAIL')} InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                            <icons.emailInput />
                        </InputAdornment>
                    ),
                }}
                    value={email}
                    type='email'
                    onchange={e => {
                        setEmail(e.target.value)
                        clearErrorMessage();
                    }}
                    onkeyup={(event) =>
                        event.key === "Enter" && submit()
                    }
                    helperText={
                        errorMessage.EMAIL || ''
                    } />
                <Typography sx={{ color: '#858C95', marginTop: '8px' }}>{t('FORGOT_PASSWORD.DESCRIPTION')}</Typography>
            </div>
            <ButtonCustom
                type="submit"
                onClick={() => {
                    submit()
                }}
                disabled={loading}
                textButton={t('FORGOT_PASSWORD.BUTTON.SUBMMIT')}
                btnStyle={{
                    fontSize: "16px",
                    width: "100%",
                }}
                style={{ width: "100%", }}
            />
        </div>
    )
}
